<template>
  <div
    v-show="isFullscreen"
    ref="fullScreenWrapper"
    class="fullscreen-video"
    :class="{full: isFullscreen}"
    :style="{backgroundColor: bgColor, height: remainScreenHeight}"
  >
    <Icon
      class="icon-close-info-white"
      @click="exitFullScreen"
    />
    <slot />
    <i-video
      v-if="isFullscreen"
      ref="video"
      :class="fit"
      :url="url"
      :muted="isMuted"
      :volume="volume"
      :paused="isPaused"
      :current-time="time"
      :loop="loop"
      :controls="controls"
      :autoplay="autoplay"
      :custom-listeners="{dblclick: exitFullScreen, click: onClick}"
      @ended="$emit('ended', $event)"
      @seeking="handleChange({time: $event.currentTime})"
      @volume-change="handleChange({volume: $event.volume})"
      @toggle-muted="handleChange({isMuted: $event.muted, volume: $event.volume})"
      @toggle-pause="handleChange({isPaused: $event.paused, time: $event.currentTime})"
    />
  </div>
</template>
<script>
import IVideo from '@/components/IVideo'
import Icon from '@/components/Icon'
export default {
  components: {
    IVideo,
    Icon
  },
  props: {
    url: {
      type: String,
      default: '',
      required: true
    },
    bgColor: {
      type: String,
      default: '#000'
    },
    fit: {
      type: String,
      default: 'contain' // 'contain' | 'cover'
    },
    isFullscreen: {
      type: Boolean,
      default: false
    },
    isPaused: {
      type: Boolean,
      default: false
    },
    isMuted: {
      type: Boolean,
      default: false
    },
    time: {
      type: Number,
      default: 0
    },
    volume: {
      type: Number,
      default: 1
    },
    controls: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      remainScreenHeight: '100vh'
    }
  },
  mounted () {
    window.addEventListener('keydown', this.onEscape)
    window.addEventListener('resize', this.calculateRemainHeight)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onEscape)
    window.removeEventListener('resize', this.calculateRemainHeight)
  },
  methods: {
    handleChange (option) {
      this.$emit('change', option)
    },
    onEscape (e) {
      if (e.keyCode === 27) {
        this.$emit('change', { isFullscreen: false })
      }
    },
    onClick (e) {
      e.preventDefault() // prevent dbclick trigger video fullscreen
    },
    exitFullScreen () {
      this.$emit('change', { isFullscreen: false })
    },
    calculateRemainHeight () {
      const fullScreenWrapper = this.$refs.fullScreenWrapper
      if (fullScreenWrapper && fullScreenWrapper.classList.contains('full')) {
        this.remainScreenHeight = `${window.innerHeight}px`
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.fullscreen-video {
  position: fixed
  z-index: 101
  display: flex
  flex-direction: column
  justify-content: center;
  align-items: center
  width: 0
  height: 0
  &.full {
    top: 0
    height: 100vh
    width: 100vw
  }
  .cover {
    width: 100vw
    height: 100vh
    object-fit: cover
  }
  .icon-close-info-white {
    display: block
    width: 24px
    height: 24px
    position: fixed
    top: 20px
    right: 20px
    z-index: 100
    cursor: pointer
  }
}

</style>
